import { useEffect, useState } from "react";
import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

// Common utilities and constants for roles
export const ROLES = {
    1: { name: "Tested By", id: 1 },
    2: { name: "Prepared By", id: 2 },
    3: { name: "Reviewed By", id: 3 },
    4: { name: "Authorized By", id: 4, },
};

// Get item from local storage, optionally parse if json is true
export const getStorage = (item, json) => {
    let val = localStorage.getItem(item);
    if (json)
        try {
            val = JSON.parse(val);
        } catch { }
    return val;
};
// Set item in local storage, optionally stringify if json is true
export const setStorage = (item, val, json) => {
    try {
        val = JSON.stringify(val);
    } catch { }
    return localStorage.setItem(item, val);
};

export const useGetRoleInfo = (all, type) => {
  const storage_currentRole = getStorage("currentRole", true);
  const storage_roles = (getStorage("roles", true) || []).filter(Boolean);
  
  const [roles, setRoles] = useState([]);
  const [currentRole, setCurrentRole] = useState(storage_currentRole || {});

  useEffect(() => {
    const fetchRoleData = async () => {
      try {
        // Step 1: Fetch roles based on 'all' and 'type' parameters
        let tRoles = all
          ? Object.values(ROLES) // If 'all' is true, return all roles
          : storage_roles; // Otherwise, use the roles from storage

        // Step 2: Fetch role settings from the server
        const { data: roleSettings = [] } = await axiosWithToken.get(
          `${BASE_URL}settings?_where=(keyName,like,activeRole~)~and(status,ne,-1)`
        );

        // Step 3: Create a setting map for easy lookup
        const settingMap = roleSettings.reduce((acc, { keyName, value }) => {
          const roleId = keyName.replace("activeRole", "");
          acc[roleId] = { name: value, id: roleId };
          if (roleId === currentRole?.id) {
            // Update currentRole if it matches in settings
            setCurrentRole({ name: value, id: roleId });
            setStorage("currentRole", { name: value, id: roleId });
          }
          return acc;
        }, {});

        // Step 4: Merge role settings with roles and filter out invalid ones
        tRoles = tRoles
          .map((role) => ({ ...role, ...settingMap[role.id] }))
          .filter((role) => role.name?.toLowerCase() !== "false");

        // Step 5: Set the final roles and currentRole in state and localStorage
        setRoles(tRoles);
        setStorage("roles", tRoles);

      } catch (err) {
        console.error("Error fetching role settings:", err);
      }
    };

    fetchRoleData();
  }, []);

  // Helper to update current role
  const updateCurrentRole = (newCurrentRole) => {
    setCurrentRole(newCurrentRole);
    setStorage("currentRole", newCurrentRole);
  };

  // Helper to update roles
  const updateRoles = (newRoles) => {
    setRoles(newRoles);
    setStorage("roles", newRoles);
  };

  return {
    roles,
    currentRole,
    setCurrentRole: updateCurrentRole,
    setRoles: updateRoles,
  };
};
